import React, { Component } from "react";
import BreadCumb from "./../component/Department/BreadCumb";
import BreadCrumbOwn from "../component/Essentials/BreadCrumbOwn";
import { Grid, Container, Typography } from "@material-ui/core";

export default class ContactUsContainer extends Component {
  render() {
    return (
      <div>
        <BreadCrumbOwn title="Contact Us" />
        <Container style={{ minHeight: "600px" }}>
          <br></br>
          <div>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <ul>
                  <li
                    style={{
                      paddingBottom: "",
                      listStyle: "none",
                      fontSize: "1.2em",
                      marginLeft: "-40px",
                    }}
                  >
                    <Typography
                      variant="h4"
                      style={{ margin: "1em 0", fontWeight: 700 }}
                      gutterBottom
                    >
                      Postal Address
                    </Typography>
                    <Typography variant="h6">
                      Office of the Coordinator Internship and Apprenticeship
                      Cell,
                      <br />
                      Dispur College, Ganeshguri, Guwahati, Kamrup
                      (Metropolitan), Assam, India .
                      <br />
                      Pin : 781006
                      <br />
                      Email:{" iacdc01@gmail.com "}
                      <a href={`mailto:iacdc01@gmail.com `}></a>
                      <br />
                      Webmail:{" iacdc01@gmail.com "}
                      <a href={`mailto:iacdc01@gmail.com `}></a>
                      <br />
                      Website:{" "}
                      <a href={`https://dispurcollege.ac.in`}>
                        https://dispurcollege.ac.in
                      </a>{" "}
                      <br />
                    </Typography>
                  </li>
                </ul>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.4641484306544!2d91.78450509999999!3d26.149009199999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375a5922a0100723%3A0x48c22d59955cd557!2sDispur%20College!5e0!3m2!1sen!2sin!4v1765972145229!5m2!1sen!2sin"
                  width="600"
                  height="450"
                  style="border:0;"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                  width="600"
                  height="400"
                  style={{ border: 0, maxWidth: "100%" }}
                  allowfullscreen=""
                  loading="lazy"
                ></iframe>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    );
  }
}
